const correlationId = Date.now().toString() // Generate unique correlation ID

function getCookie(name: string) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts && parts.length === 2) return parts.pop()?.split(';').shift()
  return null
}

function getBrand() {
  return window.jlData.page.productPages.brand || '' // Fetch brand or default to "unknown"
}

export function initScript(scriptSrc: string) {
  // Prevent duplicate injection by checking for existing script
  const existingScript = document.querySelector(`script[src="${scriptSrc}"]`)
  if (existingScript) {
    console.warn('Script already injected:', scriptSrc)
    return
  }

  var script = document.createElement('script')
  script.setAttribute('src', scriptSrc)

  script.onload = function () {
    if (window.newrelic) {
      window.newrelic.addPageAction('ConferWith-Script-Loaded', {
        correlationId: correlationId,
        scriptSrc: scriptSrc,
        status: 'success',
        brand: getBrand(), // Log brand
      })
    }
    console.log('Script loaded successfully:', scriptSrc)

    // Start monitoring for the widget appearance
    checkWidgetAppearance()
  }

  script.onerror = function () {
    const analyticsCookie = getCookie('JOHNLEWIS_ENSIGHTEN_PRIVACY_Analytics')

    if (window.newrelic) {
      window.newrelic.addPageAction('ConferWith-Script-Error', {
        correlationId: correlationId,
        scriptSrc: scriptSrc,
        status: 'error',
        message: 'Script failed to load',
        analyticsCookie: analyticsCookie, // Log cookie value
        brand: getBrand(), // Log brand
      })
    }
    console.error('Error loading script:', scriptSrc, 'Analytics Cookie:', analyticsCookie)
  }

  document.body.appendChild(script)
}

function checkWidgetAppearance() {
  const widgetId = 'conferwith'
  let elapsedTime = 0
  const checkInterval = 5000 // Check every 5 seconds
  const maxWaitTime = 30000 // Stop checking after 30 seconds

  const interval = setInterval(() => {
    console.log('Checking for ConferWith widget...')
    if (document.getElementById(widgetId)) {
      clearInterval(interval)
      if (window.newrelic) {
        window.newrelic.addPageAction('ConferWith-Widget-Shown', {
          correlationId: correlationId,
          widgetId: widgetId,
          status: 'success',
          timeTakenSeconds: elapsedTime / 1000,
          brand: getBrand(), // Log brand
        })
      }
      console.log('Widget appeared in the DOM:', widgetId)
    } else if (elapsedTime >= maxWaitTime) {
      clearInterval(interval)

      const analyticsCookie = getCookie('JOHNLEWIS_ENSIGHTEN_PRIVACY_Analytics')

      if (window.newrelic) {
        window.newrelic.addPageAction('ConferWith-Widget-Not-Shown', {
          correlationId: correlationId,
          widgetId: widgetId,
          status: 'failure',
          message: 'Widget did not appear within 30 seconds',
          analyticsCookie: analyticsCookie, // Log cookie value
          brand: getBrand(), // Log brand
        })
      }
      console.warn('Widget did not appear within 30 seconds:', widgetId, 'Analytics Cookie:', analyticsCookie)
    }
    elapsedTime += checkInterval
  }, checkInterval)
}
